import Collection from './views/collection.c';
export default Collection;
